import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BookViewer from '../../components/BookViewer';
import { BookService } from '../../services/book/book.service';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import './display_book.scss';

interface BookContent {
  book_name: string;
  pages: Array<{
    [key: string]: any;
  }>;
}

const DisplayBook: React.FC = () => {
  const { bookId } = useParams<{ bookId: string }>();
  const [bookContent, setBookContent] = useState<BookContent | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const bookService = new BookService();
  const { shouldUseScrollLayout } = useResponsiveLayout();

  useEffect(() => {
    const fetchBookContent = async () => {
      if (!bookId) {
        setError('Book ID is required');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        const response = await bookService.getBookContentByHashedId(bookId);
        setBookContent(response);
      } catch (error) {
        console.error('Error fetching book content:', error);
        setError('Failed to load book content. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchBookContent();
  }, [bookId]);

  if (error) {
    return (
      <div className="display-book">
        <div className="error-container">
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="display-book">
      <BookViewer 
        bookContent={bookContent}
        isLoading={isLoading}
        showHeader={!shouldUseScrollLayout}
        className="full-page"
      />
    </div>
  );
};

export default DisplayBook;
